import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiPrivateService } from "../../api/api";
import { AuthSlice } from "../reducers/AuthSlice.ts";
import Cookies from "js-cookie";
import { refreshToken } from "./site";
import { getUser } from "../../utils/index"; // убедись, что путь корректен

const refresh_token = Cookies.get("refresh_token");

export const fetchData = createAsyncThunk(
  "data/fetchData",
  async (_, thunkAPI) => {
    // thunkAPI.dispatch(siteSlice.actions.setIsLoading(true))
    try {
      const response = await apiPrivateService.get("/org");
      const isPerson = response.data.data.who === "person";
      var data = response.data.data;
      const applicant_card = response.data.data.offered_cards;
      const applicant_credit = response.data.data.offered_credits;
      const applicant_document = response.data.data.offered_documents;
      var applicants = applicant_card.concat(
        applicant_credit,
        applicant_document,
      );
      applicants.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      data.applicants = applicants;
      thunkAPI.dispatch(AuthSlice.actions.setIsPerson(isPerson));
      // thunkAPI.dispatch(siteSlice.actions.setIsLoading(false))
      return data;
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(refreshToken({ action: fetchData, data: "" }));
        return thunkAPI.rejectWithValue(e.message);
      } else {
        // Cookies.remove("access_token");
        // thunkAPI.dispatch(siteSlice.actions.setIsLoading(false))
        return thunkAPI.rejectWithValue(e.message);
      }
    }
  },
);

export const fetchSchedule = createAsyncThunk(
  "data/fetchSchedule",
  async (_, thunkAPI) => {
    try {
      const response = await apiPrivateService.get("/org/schedule");
      if (response.status === 200) {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(true));
        return response.data;
      }
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(refreshToken({ action: fetchSchedule, data: "" }));
      } else {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(false));
        // Cookies.remove("access_token");
        return thunkAPI.rejectWithValue(e.message);
      }
      // thunkAPI.dispatch(siteSlice.actions.setIsLoading(false))
    }
  },
);

export const fetchPaymentCardTypes = createAsyncThunk(
  "data/fetchPaymentCardTypes",
  async (_, thunkAPI) => {
    try {
      const response = await apiPrivateService.get("/org/payment-card-types");

      if (response.status === 200) {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(true));
        const data = response.data?.data ?? {};
        return data;
      } else {
        return thunkAPI.rejectWithValue("Invalid response status");
      }
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(
          refreshToken({ action: fetchPaymentCardTypes, data: "" }),
        );
      } else {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(false));
        return thunkAPI.rejectWithValue(e.message || "Unknown error");
      }
    }
  },
);

export const fetchNationalities = createAsyncThunk(
  "data/fetchNationalities",
  async (_, thunkAPI) => {
    try {
      const response = await apiPrivateService.get("/nationalities");

      if (response.status === 200) {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(true));
        const data = response.data?.data?.nationalities ?? [];
        return data;
      } else {
        return thunkAPI.rejectWithValue("Invalid response status");
      }
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(
          refreshToken({ action: fetchNationalities, data: "" }),
        );
      } else {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(false));
        return thunkAPI.rejectWithValue(e.message || "Unknown error");
      }
    }
  },
);

export const fetchCountries = createAsyncThunk(
  "data/fetchCountries",
  async (_, thunkAPI) => {
    try {
      const response = await apiPrivateService.get("/countries");

      if (response.status === 200) {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(true));
        const data = response.data?.data?.countries ?? [];
        return data;
      } else {
        return thunkAPI.rejectWithValue("Invalid response status");
      }
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(refreshToken({ action: fetchCountries, data: "" }));
      } else {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(false));
        return thunkAPI.rejectWithValue(e.message || "Unknown error");
      }
    }
  },
);

export const fetchReceivers = createAsyncThunk(
  "data/fetchReceivers",
  async (_, thunkAPI) => {
    try {
      const userResponse = await getUser();
      const user_id = userResponse?.data?.user_id;

      if (!user_id) {
        return thunkAPI.rejectWithValue("User ID not found");
      }

      const response = await apiPrivateService.get(
        `/payees?applicant_id=${user_id}`,
      );

      if (response.status === 200) {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(true));
        const data = response.data?.data?.payees ?? [];
        return data;
      } else {
        return thunkAPI.rejectWithValue("Invalid response status");
      }
    } catch (e) {
      if (refresh_token && e.response?.status === 401) {
        thunkAPI.dispatch(refreshToken({ action: fetchReceivers, data: "" }));
      } else {
        thunkAPI.dispatch(AuthSlice.actions.setIsAuth(false));
        return thunkAPI.rejectWithValue(e.message || "Unknown error");
      }
    }
  },
);

export const fetchInterPayments = createAsyncThunk(
  "data/fetchInterPayments",
  async (page = 1, thunkAPI) => {
    try {
      const response = await apiPrivateService.get(`/international-payments`, {
        params: { page },
      });

      const ip = response?.data?.data?.international_payments;
      const rawList = Array.isArray(ip?.data) ? ip.data : [];

      // helper для безопасного parse массивов
      const parseArr = (maybeJson) => {
        if (typeof maybeJson === "string") {
          try {
            const arr = JSON.parse(maybeJson);
            return Array.isArray(arr) ? arr : [];
          } catch {
            return [];
          }
        }
        return Array.isArray(maybeJson) ? maybeJson : [];
      };

      // нормализуем элементы: парсим файловые массивы
      const list = rawList.map((item) => ({
        ...item,
        payee_documents: parseArr(item?.payee_documents),
        payer_documents: parseArr(item?.payer_documents),
      }));

      // сортировка по created_at (убывание)
      list.sort(
        (a, b) =>
          new Date(b?.created_at ?? 0).getTime() -
          new Date(a?.created_at ?? 0).getTime(),
      );

      return {
        list,
        current_page: ip?.current_page ?? 1,
        last_page: ip?.last_page ?? 1,
        total: ip?.total ?? list.length,
        per_page: ip?.per_page ?? list.length,
      };
    } catch (e) {
      if (refresh_token && e?.response?.status === 401) {
        thunkAPI.dispatch(
          refreshToken({ action: fetchInterPayments, data: page }),
        );
        return thunkAPI.rejectWithValue(e?.message);
      } else {
        return thunkAPI.rejectWithValue(e?.message);
      }
    }
  },
);

export const fetchPreviousPaymentFiles = createAsyncThunk(
  "data/fetchPreviousPaymentFiles",
  async (payment_card_type_id, thunkAPI) => {
    try {
      const response = await apiPrivateService.get(
        "/v2/international-payments/check-previous-files",
        { params: { payment_card_type_id } },
      );
      return response.data.data; // { previous_payment_id, reusable_files }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
